/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { USER } from '../graphql/user';
import apolloClient from '../services/apollo-client';

const transactionsProvider = {
  getList: async (_resource, _params) => Promise,

  getOne: async (_resource, params) => {
    const response = await apolloClient.query({
      query: USER,
    });
    return {
      data: {
        ...response.data.user,
        userId: response.data.user.id,
        id: params.id,
      },
    };
  },

  getMany: async (resource, params) => Promise,

  getManyReference: (resource, params) => Promise,

  create: async (resource, params) => Promise,

  update: async (resource, params) => Promise,

  updateMany: async (resource, params) => Promise,

  delete: (resource, params) => Promise,

  deleteMany: (resource, params) => Promise,
};

export default transactionsProvider;
